import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import Router from 'components/Router';
import ScrollToTop from 'components/ScrollToTop';
import store, { history } from 'utils/store';
import { createTheme, ThemeProvider, alpha } from '@mui/material/styles';
import { indigo } from '@mui/material/colors';
import { pink } from '@mui/material/colors';
import { grey } from '@mui/material/colors';
import { lighten } from '@mui/material/styles';
import { buttonStyle } from 'utils/commonStyles';
import I18n from 'utils/locales';

class App extends React.Component {
  getTheme() {
    const paletteTheme = createTheme({
      palette: {
        primary: {main: window.THEME_PRIMARY_COLOUR ? '#' + window.THEME_PRIMARY_COLOUR : indigo[500]},
        secondary: {main: window.THEME_SECONDARY_COLOUR ? '#' + window.THEME_SECONDARY_COLOUR : pink[500]},
        grey: {main: grey[300], dark: grey[400]}
      },
      typography: {
        fontFamily: window.CUSTOM_FONT
      }
    });

    return createTheme(paletteTheme, {
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            body: {
              backgroundColor: window.BACKGROUND_COLOUR || '#fafafa'
            }
          }
        },
        MuiButton: {
          variants: [
            {
              props: { variant: 'contained', color: 'grey' },
              style: {
                color: paletteTheme.palette.getContrastText(paletteTheme.palette.grey[300])
              }
            }
          ],
          styleOverrides: {
            root: {
              borderRadius: buttonStyle(window.BUTTON_STYLE),
              textTransform: 'initial',
              padding: window.BUTTON_STYLE == 'rounded' ? '12px 30px' : '12px 22px',
              '&.Mui-focusVisible': {
                outline: window.VISIBLE_FOCUS_COLOUR ? '#' + window.VISIBLE_FOCUS_COLOUR : indigo[500],
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineOffset: '1px'
              },
              '.MuiTouchRipple-root': {
                display: 'none'
              }
            },
            containedPrimary: {
              backgroundColor: window.PRIMARY_BUTTON_COLOUR ? '#' + window.PRIMARY_BUTTON_COLOUR : indigo[500],
              color: window.PRIMARY_BUTTON_FONT_COLOUR ? '#' + window.PRIMARY_BUTTON_FONT_COLOUR : 'white',
              '&:hover': {
                backgroundColor: window.PRIMARY_BUTTON_COLOUR ? lighten('#'+window.PRIMARY_BUTTON_COLOUR, 0.3) : indigo[800]
              }
            },
            outlinedPrimary: {
              borderColor: window.PRIMARY_OUTLINED_BUTTON_COLOUR ? '#' + window.PRIMARY_OUTLINED_BUTTON_COLOUR + '80' : alpha(indigo[500], 0.5),
              color: window.PRIMARY_OUTLINED_BUTTON_FONT_COLOUR ? '#' + window.PRIMARY_OUTLINED_BUTTON_FONT_COLOUR : indigo[500],
              '&:hover': {
                borderColor: window.PRIMARY_OUTLINED_BUTTON_COLOUR ? '#' + window.PRIMARY_OUTLINED_BUTTON_COLOUR : indigo[500]
              }
            }
          }
        },
        MuiInput: {
          styleOverrides: {
            underline: {
              '&:before': {
                borderBottom: window.BODY_FONT_COLOUR != '#' ? '1px solid ' + window.BODY_FONT_COLOUR : '1px solid rgba(0, 0, 0, 0.42)'
              }
            }
          }
        },
        MuiTablePagination: {
          styleOverrides: {
            toolbar: {
              justifyContent: 'center'
            },
            spacer: {
              flex: 'none'
            },
            caption: {
              fontSize: '1rem'
            }
          }
        }
      }
    })
  }

  render() {
    return (
      <Provider store={store}>
        <I18n>
          <ConnectedRouter history={history}>
            <ThemeProvider theme={this.getTheme()}>
              <ScrollToTop>
                <Router />
              </ScrollToTop>
            </ThemeProvider>
          </ConnectedRouter>
        </I18n>
      </Provider>
    )
  }
}

export default App;
